import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";
import { AnnualTradingReportFilter } from "../types";

export const getAnnualReport = (
  user: User,
  filter: AnnualTradingReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getannualtradingreport",
    params: {
      userid: user.userId,
    },
  });
};

export default getAnnualReport;
